module.exports = __webpack_public_path__ + "img/gx.ba30ffe4.png";